import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/image_4.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-307d3374")

_pushScopeId("data-v-307d3374")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "aboutPageHeader" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "aboutBanner" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "pageTitle" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "aboutInfo" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "wrapper" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = { class: "titleBlock" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "contentBlock" }
const _hoisted_15 = { class: "textBlock" }
const _hoisted_16 = { class: "right" }
const _hoisted_17 = { class: "joinSection about" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "joinBlock" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "img dotsBottom" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "image"
  })
], -1)
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "title md" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "textBlock" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "light" }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.t('aboutPage.header.pageTitle')), 1),
            _createVNode("div", _hoisted_7, [
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.t('aboutPage.header.info1')), 1),
                _createVNode("span", null, _toDisplayString(_ctx.t('aboutPage.header.info2')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t('aboutPage.aboutInfo.left.title')), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("p", null, _toDisplayString(_ctx.t('aboutPage.aboutInfo.left.text')), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", {
              class: _ctx.quoteBlock,
              style: _ctx.quoteBlockStyle
            }, [
              _createVNode("p", {
                class: _ctx.pquoteBlock,
                style: _ctx.pquoteBlockStyle,
                "data-wow-delay": "1s"
              }, _toDisplayString(_ctx.t('aboutPage.aboutInfo.right.quote')), 7)
            ], 6)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("div", _hoisted_21, [
            _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t('aboutPage.joinSection.title')), 1),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('aboutPage.joinSection.text')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})